import { App } from '@capacitor/app';

const listeners = new Map(); // pattern → callback
let initialized = false;
let pendingUrl = null; // buffered URL received before any listener was registered

/**
 * Initialise the single appUrlOpen listener.
 * Safe to call multiple times — only registers once.
 * Call this at app startup so the listener is ready before any component mounts.
 */
export function initDeeplink() {
  if (initialized) return;
  initialized = true;

  App.addListener('appUrlOpen', (data) => {
    const url = data.url;
    console.log('[deeplink] appUrlOpen:', url);

    for (const [pattern, callback] of listeners) {
      if (url.includes(pattern)) {
        callback(url);
        return;
      }
    }
    // No listener matched yet — buffer so late registrations can consume it
    pendingUrl = url;
  });
}

/**
 * Register a callback for a URL pattern.
 * Returns an unsubscribe function.
 * If a buffered URL matches, the callback is fired asynchronously on registration.
 */
export function onDeepLink(pattern, callback) {
  listeners.set(pattern, callback);

  // Consume any URL that arrived before this listener was registered
  if (pendingUrl && pendingUrl.includes(pattern)) {
    const url = pendingUrl;
    pendingUrl = null;
    setTimeout(() => callback(url), 0);
  }

  return () => listeners.delete(pattern);
}
